module.exports = __webpack_public_path__ + "static/media/mapMainMobile.23501405.png";